/* eslint-disable no-useless-escape */
const emailRegEx =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const isValidEmail = (email) => emailRegEx.test(email) && email.length <= 255;

export const isValidPassword = (password) => password.length > 6 && password.length <= 255;

export const isValidName = (name) => name.length > 0 && name.length <= 255;
